/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import {
  selectBookBasisValuesSelectionOptions,
  selectFetchingBookBasisValues,
} from "state/bookAnalytics/selectors";
import {
  selectAnalyticValuesSelectionOptions,
  selectFetchingAnalyticValues,
} from "state/analytics/selectors";
import { useSelector } from "react-redux";
import { summaryTypeOptions } from "state/selections/Constants/SummaryType";
import { Grid, Cell } from "styled-css-grid";

const BookAnalyticsSelectorComplication = ({ setDefinition, definition }) => {
  const analyticOptions = useSelector(selectAnalyticValuesSelectionOptions);
  const filterAmortBookAnalyticOptions = analyticOptions.filter((option) =>
    option.label.toLowerCase().includes("amort")
  );
  const fetchingAnalyticValues = useSelector(selectFetchingAnalyticValues);
  const bookBasisOptions = useSelector(selectBookBasisValuesSelectionOptions);
  const fetchingBookBasisValues = useSelector(selectFetchingBookBasisValues);
  const [setBookAnalytic, setBasis, setSummary] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setBookAnalytic(value)),
      (value) => setDefinition(definition.setBasis(value)),
      (value) => setDefinition(definition.setSummary(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell>
        <Combobox
          options={filterAmortBookAnalyticOptions}
          onChange={setBookAnalytic}
          isLoading={fetchingAnalyticValues}
          value={definition.bookAnalytic}
          label="Book Analytic:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell>
        <Combobox
          options={bookBasisOptions}
          onChange={setBasis}
          isLoading={fetchingBookBasisValues}
          value={definition.basis}
          label="Basis:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell>
        <Combobox
          options={summaryTypeOptions}
          onChange={setSummary}
          value={definition.summary}
          label="Acc/Bmk/Rel:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={125}
        />
      </Cell>
    </Grid>
  );
};

BookAnalyticsSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(BookAnalyticsSelectorComplication);
